import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Switch } from "@headlessui/react";
const SToggle = ({ className, value, disabled = false, onToggle })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: className || "",
        children: /*#__PURE__*/ _jsx(Switch, {
            checked: value,
            onChange: ()=>onToggle(!value),
            style: {
                width: "20.5px",
                height: "12.5px"
            },
            className: `${!disabled ? value ? "bg-brand-primary bg-opacity-60" : "bg-white bg-opacity-40" : "bg-white bg-opacity-40 opacity-50"}
          relative inline-flex flex-shrink-0
          border border-transparent rounded-full cursor-pointer
          transition-colors ease-in-out duration-200 focus:outline-none
          focus-visible:ring-2 focus-visible:ring-white
          focus-visible:ring-opacity-75`,
            children: /*#__PURE__*/ _jsx("span", {
                "aria-hidden": "true",
                style: {
                    width: "10.8px",
                    height: "10.8px"
                },
                className: `

          	bg-white
            ${!disabled ? value ? "translate-x-2" : "translate-x-0" : "translate-x-0"}
            pointer-events-none inline-block
            rounded-full
            shadow-lg transform ring-0 transition
            ease-in-out duration-200`
            })
        })
    });
};
export default SToggle;
